import React from 'react';
import { isModuleNotFoundError, NotFound } from '@components/ErrorBoundary';
import { ErrorTypes, Loading } from '@fabric-ui/components';
import SomethingWentWrong from '@fabric-ui/icons/svg/emptyStates/Something went Wrong.svg';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { createRouter } from '@tanstack/react-router';
import { routerContextDefaultValues } from './RouterContext';
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <NotFound />,
  defaultErrorComponent: error => {
    if (isModuleNotFoundError(error.error)) {
      window.location.reload();
      return (
        <Box sx={flex.colCenter}>
          <Loading />
        </Box>
      );
    }
    return (
      <NotFound
        text="Something Went Wrong..."
        image={SomethingWentWrong}
        buttonProps={
          error.error.message === ErrorTypes.AvContext
            ? {
                variant: 'contained',
                children: 'Refresh to reload',
                onClick: () => window.location.reload(),
                sx: { fontWeight: 600 },
              }
            : undefined
        }
      />
    );
  },
  defaultPreload: 'intent',
  context: routerContextDefaultValues,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default router;
